import { FC } from "react";
import classNames from "classnames";

import { HeaderBrandsSelectorProps } from "./types";
import ValueWithDifference from "../ValueWithDifference";
import { getHoursDiff } from "./utils/getHoursDiff";
import Skeleton from "../Skeleton/Skeleton";
import { EyeIcon, TrophyIcon } from "../icons";
import { getSentimentIcon } from "../../utils/getSentimentIcon";
import BrandWithCompetitorsSelect from "../BrandWithCompetitorsSelect/BrandWithCompetitorsSelect";

import styles from "./HeaderBrandsSelector.module.css";



const HeaderBrandsSelector: FC<HeaderBrandsSelectorProps> = ({
  score,
  lastUpdateTime,
  className,
  onBrandChange,
}) => {
  const hoursSinceLastUpdate = getHoursDiff(lastUpdateTime);

  const renderInfo = () => {
    if (!score) 
      return <Skeleton className={styles["info__value"]} height={40} width={480} variant="text" />;

    const SentimentIcon = getSentimentIcon(score?.avg_sentiment);

    return (
      <>
        <ValueWithDifference
          className={styles["info__value"]}
          icon={<EyeIcon />}
          isWhiteStyle={true}
          value={score?.avg_visibility}
          difference={score?.week_difference_visibility}
        />
        <ValueWithDifference
          className={styles["info__value"]}
          icon={<SentimentIcon />}
          isWhiteStyle={true}
          value={score?.avg_sentiment}
          difference={score?.week_difference_sentiment}
        />
        <ValueWithDifference
          className={styles["info__value"]}
          icon={<TrophyIcon />}
          isWhiteStyle={true}
          value={score?.avg_position}
          difference={score?.week_difference_position}
        />
      </>
    );
  }

  const renderLabel = () => {
    if (hoursSinceLastUpdate === undefined || hoursSinceLastUpdate === null)
      return <Skeleton height={24} width={133} variant="text" />;

    return (
      <p>UPDATED {hoursSinceLastUpdate} H AGO</p>
    );
  }

  return (
    <header className={classNames(styles["header-prompts"], className)}>
      <div className={classNames(styles["header-prompts__select"], styles["select"])}>
        <BrandWithCompetitorsSelect onChange={onBrandChange} />
      </div>
      <div className={classNames(styles["header-prompts__info"], styles["info"])}>
        <div className={styles["info__label"]}>
          <p>7-Day AI Score</p>
          {renderLabel()}
        </div>
        {renderInfo()}
      </div>
    </header>
  );
};

export default HeaderBrandsSelector;
